import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ModalSolicitarNovaObraComponent } from 'src/app/shared/components/modal-solicitar-nova-obra/modal-solicitar-nova-obra.component';

@Component({
  selector: 'app-bloco-solicitar-nova-obra',
  standalone: true,
  imports: [CommonModule, MatIconModule, ModalSolicitarNovaObraComponent],
  templateUrl: './bloco-solicitar-nova-obra.component.html',
  styleUrls: ['./bloco-solicitar-nova-obra.component.scss'],
})
export class BlocoSolicitarNovaObraComponent implements OnInit {
  showModal = false;
  loading   = true;

  @Output() loading$ = new EventEmitter<boolean>();

  ngOnInit(): void {
    setTimeout(() => (this.loading = false), 300);
  }

  abrirModal(): void   { this.showModal = true; }
  fecharModal(): void  { this.showModal = false; }
  onModalLoading(s: boolean): void { this.loading$.emit(s); }
}